/* eslint-disable import/prefer-default-export */

import { PreviewPanelActions } from '../../constants';

export const setReload = (reload) => ({
  type: PreviewPanelActions.SET_RELOAD,
  reload,
});
